import { render, staticRenderFns } from "./NewsFeed.vue?vue&type=template&id=1e45970b&scoped=true&"
import script from "./NewsFeed.vue?vue&type=script&lang=js&"
export * from "./NewsFeed.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeed.vue?vue&type=style&index=0&id=1e45970b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45970b",
  null
  
)

export default component.exports